/**
 * Created by tofael on 3/9/18.
 */
import React from 'react';
import utils from '../utility/utils';
import {connect} from 'react-redux';
import DatePicker from 'material-ui/DatePicker';

import api from '../utility/api';
import List from '../screens/list/';
import appConstants from '../utility/app-constants';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import { getListUIPreference, setListUIPreference } from '../utility/local-storage';

class ConsumersList extends React.Component {

  constructor() {
    super(...arguments);
    let {defaultSort, pageSize} = this.loadUIPreferences();
    this.state = {
      consumers: [],
      sortPref: defaultSort,
      pageSize
    };
  }

  componentDidMount() {
    this.getConsumersList();
  }

  loadUIPreferences() {
    let listPreference = getListUIPreference(appConstants.LIST.CONSUMERS);
    let defaultSort = listPreference && listPreference.sortPref? listPreference.sortPref :
      [
        {
          id: 'date',
          desc: false
        }
      ];
    let pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  getConsumersList(){
    this.props.dispatch(asyncStart());
    api.getConsumers()
      .then(resp => {
        this.props.dispatch(asyncEnd());
        this.setState({consumers: resp});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.CONSUMERS);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.CONSUMERS, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.CONSUMERS);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.CONSUMERS, currentPreference);
  }

  render() {
    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        show: false
      },
      {
        id: 'date',
        Header: 'Registration Date',
        maxWidth:180,
        accessor: d =>  new Date(d.created_at),
        Cell: props => <span>{utils.toDate(props.value)}</span>,
        filterMethod: (filter, row) => {
          return filter === null || filter.value === null ||utils.isSameDay(filter.value, row[filter.id])
        },
        Filter: ({ filter, onChange }) =>
          <DatePicker
            cancelLabel='Clear'
            textFieldStyle={{height: '100%', position: 'inherit'}}
            value={filter ? filter.value : null}
            onDismiss={()=> onChange(null)}
            onChange={(event, date) => onChange(date)}
          />
      },
      {
        Header: 'Name',
        accessor: 'name'
      },
      {
        Header: 'Phone',
        accessor: 'phone'
      },
      {
        id: 'totalPatients',
        Header: 'Patients',
        accessor: d => d.patient.length
      }
    ];

    let {consumers, pageSize, sortPref} = this.state;
    let {isLoading} = this.props.application;

    let reactTableProps = {
      data: consumers,
      columns,
      isLoading,
      defaultSorted: sortPref,
      defaultPageSize: pageSize,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this),
      noDataText: 'No consumers found',
      getTdProps: (state, rowInfo) => {
        return {
          onClick: e => {
            // if (rowInfo)
            //   hashHistory.push('/doctor/' + rowInfo.row.id)
          }
        }
      }
    };

    return (
      <List
        title="Consumers"
        reactTableProps={reactTableProps}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(ConsumersList);


// WEBPACK FOOTER //
// ./src/containers/consumers.js